/*
 *  ************************************************************************
 *  *  © [2015 - 2024] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import defaultImage from "../../../../../../assets/icons/default-image.svg";
import { SvgHandler } from "../../../../svg-handler/svg-handler";
import "./card-image.m.css";

export const CardImage = ({ imageUrl, title, type = "plan" }) => {
  return (
    <div styleName="image" className="plan-image" data-test-id={`${type}-image`}>
      {imageUrl ? (
        <img src={imageUrl} alt={title} />
      ) : (
          <SvgHandler xlinkHref={defaultImage} width="100%" height="100%" />
        )}
    </div>
  );
};
